<template>
  <span class="tw-text-4xl tw-font-medium tw-text-dorian-gray-500">
    <slot />
  </span>
</template>
